import React from 'react';

import { ILink } from '../../../../../types/contentful';

import { Link } from './Link';
import { FooterNavItemList } from './styles';

interface NavListProps {
  links: ILink[];
}

export function NavList({ links }: NavListProps) {
  return (
    <FooterNavItemList columnCount={links.length}>
      {links && links.map(({ fields }, idx) => <Link key={idx} {...fields} />)}
    </FooterNavItemList>
  );
}
